import { ThemeProvider } from "@material-ui/core";
import "core-js/es/map";
import "core-js/es/set";
import React from "react";
import { Subscription } from "rxjs";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { wbMUITheme } from "wbm-material-ui-theme";
import { IBrandOrService } from "./components/brandsAndServices/brandOrService";
import DivSafeZone from "./components/divSafeZone/divSafeZone";
import WBMMainHeader from "./components/wbmMainHeader";
import ConfigProps from "./constants/configProps";
import { IDisplayState } from "./interfaces/IDisplayState";
import { INavToken } from "./interfaces/INavToken";
import { IPropsResponse } from "./interfaces/IPropsResponse";
import { IShoppingLocation } from "./interfaces/IShoppingLocation";
import { AddressesService } from "./utilities/addressesService";
import ConfigPropService, {
  setConfigPropsProps,
} from "./utilities/configPropService";
import { setNavTokenProps } from "./utilities/navigationTokensService";
import { setVisitId } from "./utilities/sessionCacheService";
import { setDisplayUserInfo } from "./utilities/userService";
import {
  setPreLoadedLoginUrl,
  setPreLoadedRegistrationUrl,
  setPreLoadedSwitchAccountUrl,
} from "./utilities/loginUrlService";
import { setShoppingLocation } from "@wbmason/main-header-api";
import {
  MerchZonesService,
  mzsAccountNumber,
} from "./utilities/merchZonesService";
import { IMerchZone } from "./interfaces/IMerchZone";
import { BaseHostUrlService } from "./utilities/baseHostUrlService";
import EnvironmentService from "./utilities/environmentService";
import { RegistrationSettingsService } from "./utilities/registrationSettingsService";
export interface IWbmMainHeaderAppProps extends IPropsResponse {
  visitId: string;
  navTokens: Record<string, INavToken>;
}

export interface IWbmMainHeaderAppState {
  customLogo?: string;
  firstName: string;
  accountNumber: string;
  customerAccountName: string;
  isLoggedIn: boolean;
  isCookied: boolean;
  isApprover: boolean;
  brandsAndServices: IBrandOrService[];
  hasMoreThanOneList: boolean;
  displayState: IDisplayState;
  shoppingLocation?: IShoppingLocation;
  isRecommendationsEventLoaded: boolean;
  isEcom: boolean;
}

const mzsEventAddedId = "wbm_mzs_event_added";

function priceAndRenderRecommendations(event: CustomEvent<IMerchZone>) {
  MerchZonesService.priceAndRenderRecommendations(
    event.detail.merchZoneId,
    event.detail.couponId,
    event.detail.containerWidth,
    event.detail.containerHeight,
  );
}

class App extends React.Component<
  IWbmMainHeaderAppProps,
  IWbmMainHeaderAppState
> {
  private configPropSubscription: Subscription | null = null;
  private shoppingLocationSubscription: Subscription | null = null;

  constructor(props: IWbmMainHeaderAppProps) {
    super(props);

    this.state = {
      customLogo: this.props.customLogo,
      firstName: this.props.firstName,
      accountNumber: this.props.accountNumber,
      customerAccountName: this.props.customerAccountName,
      isLoggedIn: this.props.isLoggedIn,
      isCookied: this.props.isCookied,
      isApprover: this.props.isApprover,
      brandsAndServices: this.props.brandsAndServices
        ? this.props.brandsAndServices
        : [],
      hasMoreThanOneList: false,
      displayState: this.setDisplayState(this.props.displayState),
      shoppingLocation: this.toCamelCase(this.props.shoppingLocation),
      isRecommendationsEventLoaded: false,
      isEcom: EnvironmentService.get().isEcom === true,
    };

    setVisitId(this.props.visitId);
    setDisplayUserInfo(this.props.displayState.displayUserInfo);

    if (this.props.navTokens) {
      setNavTokenProps(this.props.navTokens);
    }

    if (this.props.configProps) {
      setConfigPropsProps(this.props.configProps);
    }

    if (this.props.preLoadedLoginUrl) {
      setPreLoadedLoginUrl(this.props.preLoadedLoginUrl);
    }

    if (this.props.preLoadedRegistrationUrl) {
      setPreLoadedRegistrationUrl(this.props.preLoadedRegistrationUrl);
    }

    if (this.props.preLoadedSwitchAccountUrl) {
      setPreLoadedSwitchAccountUrl(this.props.preLoadedSwitchAccountUrl);
    }

    if (this.props.baseHostUrl) {
      BaseHostUrlService.set(this.props.baseHostUrl);
    }

    if (this.props.registrationSettings) {
      RegistrationSettingsService.set(this.props.registrationSettings);
    }
  }

  componentWillUnmount() {
    if (this.configPropSubscription) {
      this.configPropSubscription.unsubscribe();
    }

    if (this.shoppingLocationSubscription) {
      this.shoppingLocationSubscription.unsubscribe();
    }

    document.removeEventListener("ListsChanged", this.listsChanged);

    this.removeRecommendationsEvent();
  }

  componentDidMount() {
    if (!this.state.customLogo) {
      this.configPropSubscription = ConfigPropService.get([
        ConfigProps.CustomLogo,
      ]).subscribe((configProp: Record<string, string>) => {
        this.setState({
          customLogo: configProp[ConfigProps.CustomLogo],
        });
      });
    }

    if (!this.state.shoppingLocation) {
      this.shoppingLocationSubscription =
        AddressesService.getShoppingLocation().subscribe((shoppingLocation) => {
          if (shoppingLocation) {
            this.setState({
              shoppingLocation,
            });
            setShoppingLocation(shoppingLocation);
          }
        });
    } else {
      setShoppingLocation(this.state.shoppingLocation);
    }

    const newState: Partial<IWbmMainHeaderAppState> = {};

    if (typeof this.state.isApprover !== "boolean") {
      newState.isApprover = false;
    }

    if (Object.keys(newState).length !== 0) {
      this.setState(newState as IWbmMainHeaderAppState);
    }

    document.addEventListener("ListsChanged", this.listsChanged);

    this.addRecommendationsEvent();
  }

  setDisplayState(displayState: IDisplayState) {
    const newDisplayState = Object.assign({}, displayState);
    return newDisplayState;
  }

  listsChanged = () => {
    if (this.props.myListsUrl) {
      this.setState({
        hasMoreThanOneList: true,
      });
    }
  };

  addRecommendationsEvent(): void {
    sessionStorage.setItem(mzsAccountNumber, this.state.accountNumber);

    document.addEventListener(
      "priceAndRenderRecommendations",
      priceAndRenderRecommendations as EventListener,
    );

    this.setState({
      isRecommendationsEventLoaded: true,
    });
  }

  removeRecommendationsEvent(): void {
    document.removeEventListener(
      "priceAndRenderRecommendations",
      priceAndRenderRecommendations as EventListener,
    );

    this.setState({
      isRecommendationsEventLoaded: false,
    });

    sessionStorage.removeItem(mzsAccountNumber);
  }

  render() {
    return (
      <React.Fragment>
        <ThemeProvider theme={wbMUITheme}>
          <DivSafeZone id="header-callout" className="header-callout" />
          <WBMMainHeader
            customLogo={this.state.customLogo}
            firstName={this.state.firstName}
            customerAccountName={this.state.customerAccountName}
            accountNumber={this.state.accountNumber}
            isLoggedIn={this.state.isLoggedIn}
            isCookied={this.state.isCookied}
            userConfigurations={this.props.userConfigurations}
            isApprover={this.state.isApprover}
            displayState={this.state.displayState}
            shoppingLocation={this.state.shoppingLocation}
            workflow={this.props.workflow}
            checkoutAppUri={this.props.checkoutAppUri}
            cartId={this.props.cartId}
            brandsAndServices={this.state.brandsAndServices}
            myListsUrl={
              this.state.hasMoreThanOneList ? "" : this.props.myListsUrl
            }
            cartItemsSerialized={this.props.cartItemsSerialized}
            hasItemAgreements={this.props.hasItemAgreements}
            userConfigId={this.props.userConfigId}
            searchKeyword={this.props.searchKeyword}
            enableBottomOffset={this.props.enableBottomOffset}
            searchAction={this.props.searchAction}
            preLoadedLoginUrl={this.props.preLoadedLoginUrl}
            algoliaConfig={this.props.algoliaConfig}
            visitId={this.props.visitId}
          />
          <DivSafeZone id="header-bottom-1" className="dsz-standard" />
          <DivSafeZone id="header-bottom-2" className="dsz-standard" />
          <DivSafeZone id="header-bottom-3" className="dsz-standard" />
          {this.state.isRecommendationsEventLoaded && (
            <input
              type="hidden"
              id={mzsEventAddedId}
              name={mzsEventAddedId}
              value="1"
            ></input>
          )}
        </ThemeProvider>
      </React.Fragment>
    );
  }

  toCamelCase(
    shoppingLocation?: IShoppingLocation | Record<string, unknown>,
  ): IShoppingLocation | undefined {
    if (!shoppingLocation) {
      return undefined;
    }

    const object: Record<string, unknown> = {};

    for (const key in shoppingLocation) {
      const newKey = key[0].toLowerCase() + key.substring(1);
      object[newKey] = (shoppingLocation as Record<string, unknown>)[key];
    }

    return object as unknown as IShoppingLocation;
  }
}

export default App;
